import {combineReducers} from 'redux';
import ssoAccount from 'Users/ducks/SSO/ssoAccount';
import ssoAccounts from 'Users/ducks/SSO/ssoAccounts';
import legacyForm from 'Users/ducks/SSO/legacyForm';

export default combineReducers({
  accounts: ssoAccounts,
  account: ssoAccount,
  legacyForm: legacyForm,
});
